import { string, shape, arrayOf } from "prop-types";
import styles from "./styles/Stats.module.css";

const Stat = ({ number, text }) => {
  return (
    <div>
      <p className={styles.number}>{number}</p>
      <p className={styles.text}>{text}</p>
    </div>
  );
};

export const Stats = ({ data }) => {
  return (
    <section className={styles.container}>
      {data.header && <h2 className={styles.header}>{data.header}</h2>}
      <div className={styles.stats}>
        {data.statsList.length &&
          data.statsList.map((stat) => {
            return <Stat key={stat._key} number={stat.statNumber} text={stat.statText} />;
          })}
      </div>
    </section>
  );
};

Stats.propTypes = {
  _key: string,
  _type: string,
  header: string,
  statsList: arrayOf(
    shape({
      _key: string,
      _type: string,
      statNumber: string,
      statText: string,
    })
  ),
};

Stat.propTypes = {
  number: string,
  text: string,
};
